import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BottomSheetShell } from 'design-system';
import { CustomerNotes } from '../../../interfaces/customer-detail-notes.model';

@Component({
  selector: 'cus-customers-note-bottom-sheet',
  imports: [BottomSheetShell, DatePipe, MatButtonModule],
  templateUrl: './customers-note-bottom-sheet.html',
  styleUrl: './customers-note-bottom-sheet.scss',
})
export class CustomersNoteBottomSheet {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<CustomersNoteBottomSheet>,
    @Inject(MAT_BOTTOM_SHEET_DATA) readonly note: CustomerNotes,
  ) {}

  onClose() {
    this.bottomSheetRef.dismiss();
  }

  onEdit() {
    this.bottomSheetRef.dismiss({ action: 'edit', note: this.note });
  }
}
